import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpRequest,
  HttpEvent,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

// this intercepter is not being used, consider for removed 2/12/2026
export const httpErrorInterceptorFn = function (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  const snackbar = inject(MatSnackBar);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error instanceof HttpErrorResponse) {
        snackbar.open(`Error ${error.status}: ${error.message}`, 'close', {
          panelClass: ['error'],
        });
      }
      throw error;
    })
  );
};

function generateHttpErrorResponseMessageContent(error: HttpErrorResponse) {
  let message = {};
  if (error.error.traceId) {
    message = { ...message, traceId: error.error.traceId };
  }
  return {
    ...message,
    responseCode: error.status,
    responseText: error.statusText,
    url: error.url,
  };
}

function getParam(params: URLSearchParams, property: string): string {
  return params.get(property) ?? '';
}

function getPropertyFromSegment(
  pathSegments: string[],
  segmentName: string
): string {
  const segmentIdx = pathSegments.indexOf(segmentName);
  return segmentIdx !== -1 ? pathSegments[segmentIdx + 1] : '';
}

export const forbiddenInterceptorFn: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        const url = new URL(error.url || '');
        const params = url.searchParams;
        let accountId = {
          SourceSystemId: getParam(params, 'SourceSystemId'),
          PartitionId: getParam(params, 'PartitionId'),
          HealthSystemId: getParam(params, 'HealthSystemId'),
          AccountNumber: getParam(params, 'AccountNumber'),
        };

        if (accountId.AccountNumber === '') {
          const pathSegments = url.pathname.split('/');
          accountId.SourceSystemId = getPropertyFromSegment(
            pathSegments,
            'source-systems'
          );
          accountId.PartitionId = getPropertyFromSegment(
            pathSegments,
            'partitions'
          );
          accountId.HealthSystemId = getPropertyFromSegment(
            pathSegments,
            'health-systems'
          );
          accountId.AccountNumber = getPropertyFromSegment(
            pathSegments,
            'accounts'
          );
        }

        if (
          accountId.AccountNumber === '' &&
          typeof error.error?.text === 'function'
        ) {
          // Wait for the text() promise before navigating
          return new Observable<HttpEvent<unknown>>((subscriber) => {
            error.error
              .text()
              .then((text: string) => {
                const accountStringMatch =
                  JSON.parse(text).detail?.match(/\{.*\}/);
                accountId =
                  accountStringMatch?.length > 0
                    ? JSON.parse(accountStringMatch[0])
                    : accountId;
                router.navigate(['/access-request'], { state: { accountId } });

                subscriber.error(error);
              })
              .catch(() => {
                subscriber.error(error);
              });
          });
        }

        router.navigate(['/access-request'], { state: { accountId } });
      }
      return throwError(() => error);
    })
  );
};
